<template>
  <div>
    <v-layout row wrap class="mb-5">
      <v-flex xs12><Navbar :backButtonPath="backPath"/></v-flex>
      <responsive-flex>
        <v-flex class="loan-wrapper" xs12>
          <LoanInput
            :showLoanError="showLoanError"
            :title="loanAmountTitle"
            v-model.lazy="loanAmount"
            @blur="startLoanCheck"
          />
        </v-flex>
        <v-flex xs12 class="subheading grey--text">
          Select Financing Option 
        </v-flex>
        <v-flex xs12 class="px-3">
          <FinancingOptions
            :loanAmount="loanAmount"
          />
        </v-flex>
        <v-flex xs12
          v-if="lender.disclaimers && lender.disclaimers.length > 0"
          class="px-4 mb-4 caption text-xs-left"
        >
          <p
            v-for="disclaimer in lender.disclaimers"
            :key="disclaimer"
            v-html="disclaimer"
          />
        </v-flex>
        <v-flex xs12
          class="mt-2"
          v-else-if="lender.id === 'marlin'"
        >
          <span
            v-show="showLoanError"
            class="red--text subheading"
          >
            Loan must be between {{ moneyValue(marlin.minLoanAmount) }} and {{ moneyValue(marlin.maxLoanAmount) }}
          </span>
        </v-flex>
        <v-flex xs12
          class="mt-2"
          v-else
        >
          <span
            v-show="showLoanError"
            class="red--text subheading"
          >
            Loan must be at least $1000
          </span>
        </v-flex>
        <v-flex
          xs12
          v-if="checkPlanError && planError"
          class="my-2 subheading red--text"
        >
          A plan must be selected
        </v-flex>

        <v-flex class="mb-4 px-3">
          <v-layout>
            <template v-if="easyLinkEnabled">
              <v-flex xs12 :md6="nonPrimaryLenders">
                <EasyLinkDialog
                  :hasErrors="loanError || planError"
                  :disabled="greenskyMerchantCheck"
                  @input="easyLinkDialogClick"
                  @send="send"
                  @resend="resend"
                />
              </v-flex>
              <v-spacer />
              <v-flex xs12 v-if="nonPrimaryLenders" offset-sm2 :md6="easyLinkEnabled">
                <v-btn
                  class="full-width"
                  color="secondary"
                  @click="goToForm"
                  :disabled="greenskyMerchantCheck"
                >
                  Next
                </v-btn>
              </v-flex>
            </template>
            <template v-else>
              <v-flex xs12 v-if="nonPrimaryLenders" :md6="easyLinkEnabled">
                  <v-btn
                    class="full-width"
                    color="secondary"
                    @click="goToForm"
                    :disabled="greenskyMerchantCheck"
                  >
                    Next
                  </v-btn>
                </v-flex>
              <v-flex xs12 v-if="comfortButton" justify-center>
                <v-btn
                  class="full-width"
                  color="secondary"
                  @click="goToForm"
                  :disabled="greenskyMerchantCheck"
                >
                  Next
                </v-btn>  
              </v-flex>
            </template>
          </v-layout>
        </v-flex>
      </responsive-flex>
      <PreQualificationModal 
        :startPreQualFlow="startPreQualFlow"
        @abandonPreQualFlow="turnOffPreQualFlow"
      />
    </v-layout>
  </div>
</template>

<script>
  import EasyLinkDialog from '@/components/EasyLinkDialog'
  import FinancingOptions from 'Components/FinancingOptions.vue'
  import LoanInput from 'Components/LoanInput.vue'
  import Navbar from 'Components/Navbar.vue'
  import PreQualificationModal from 'Components/PreQualificationModal.vue'
  import ResponsiveFlex from 'Components/ResponsiveFlex.vue'
  import { currency } from 'Helpers/utilFunctions.js'
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
  import { greenskyStatusCheck } from 'Helpers/c4cAPIClient'
  import { marlin } from 'Helpers/lenders.js'
  import envVars from '@/env_vars'
  import appVars from '@/app_vars'

  export default {
    name: 'credit-application-plans',
    components: {
      EasyLinkDialog,
      FinancingOptions,
      LoanInput,
      Navbar,
      ResponsiveFlex,
      PreQualificationModal
    },
    data () {
      return {
        backPath: '/home',
        loanAmount: '',
        dollarSign: '$',
        checkPlanError: false,
        checkLoanError: false,
        marlin,
        startPreQualFlow: false,
      }
    },
    computed: {
      ...mapState({
        companyName: state => state.user.companyName,
        dealerId: state => state.user.dealerId,
        dealerPlans: state => state.user.dealerPlans,
        isEasyLinkUser: state => state.easyLink.active,
        loanPlan: state => state.loanApplication.loanPlan,
        lender: state => state.loanApplication.lender,
        roken: state => state.roken,
        storeLoanAmount: state => state.loanApplication.loanAmount,
        userAttributes: state => state.cognito.userAttributes,
        greenskyValid: state => state.preQualification.isValid,
        hasPreQual: state => state.preQualification.hasPreQual,
        preQualificationIdStatusCheck: state => state.preQualification.preQualificationIdStatusCheck,
        userEmail: state => state.user.email,
        userLastName: state => state.user.lastName,
        greenskyTraining: state => state.user.greenskyTraining,
        isComfortButton: state => state.easyLink.comfortButton
      }),
      ...mapGetters([
        'availableLenders', 'marlinURL',
      ]),
      applyURL() {
        return envVars.applyUrl + `?roken=${this.roken}` + `&loanAmount=${this.loanAmountNumber}` + `&companyName=${this.companyName}` + `&dealerId=${this.dealerId}`
      },
      greenskyMerchantCheck() {
        console.log("Is GreenSky currently active?", this.greenskyValid)
        return this.lender.id === 'greensky' && (!this.greenskyValid || this.greenskyTraining.status === 'Required' || this.greenskyTraining.duplicateAccounts)
      },
      easyLinkEnabled () {
        const userEnabled = (this.userAttributes['custom:flags'])
        ? this.userAttributes['custom:flags'].indexOf('easy-link') > -1
        : false

        return !this.isEasyLinkUser
          && appVars.easyLinkEnabled === true
          && ( envVars.easyLinkEnabled === 'true' || userEnabled )
      },
      loanAmountNumber() {
        return this.$store.getters.moneyInt(this.loanAmount)
      },
      loanAmountTitle () {
        if (this.lender.id === 'wellsfargo') {
          return 'Estimated Purchase Amount, if Known'
        } else {
          return 'Enter Loan Amount'
        }
      },
      loanError () {
        const amt = this.$store.getters.moneyInt(this.loanAmount)
        if (this.lender.id==='marlin'){
          return !(amt >=marlin.minLoanAmount && amt<=marlin.maxLoanAmount)
        }
          else {
          return !(amt >= 1000)
        }
      },
      nonPrimaryLenders() {
        return this.lender.id !== 'wellsfargo' && this.lender.id !== 'greensky'
      },
      planError () {
        if(this.lender.id==='greensky' && (!this.loanPlan.id || !this.planMinAmountMet)){
          return true
        // TODO: Update with proper loanPlan value(?)
        } else if(this.lender.id==='wellsfargo' && (!this.loanPlan.planNumber || !this.planMinAmountMet)){
          return true
        } else {
          return false
        }
      },
      showLoanError () {
        return this.checkLoanError && this.loanError
      },
      planMinAmountMet() {
        return this.loanPlan.minLoanAmount <= this.$store.getters.moneyInt(this.loanAmount)
      },
      activeAvailableLenders() {
          return this.availableLenders.filter(lender => lender.active)
      },
      comfortButton() {
        return this.isComfortButton && (this.lender.id === 'wellsfargo' || this.lender.id==='greensky') 
      }
    },
    methods: {
      ...mapActions([
        'getDealerPlans',
        'loanApplicationClear',
        'setLoanAmount', //TODO deprecate
        'sendEasyLink',
        'resendEasyLink',
        'getUserInfo',
        'savePreQualId',
        'getGreenskyLegalContent',
      ]),
      ...mapMutations([
        'setState'
      ]),
      easyLinkDialogClick() {
        if (this.loanError || this.planError) this.goToForm()
      },
      turnOffPreQualFlow(){
        this.startPreQualFlow = false
      },
      moneyValue(amount) {
        return currency(amount)
      },
      async goToForm () {
        // TODO Check signature
        if (!this.loanError && !this.planError ) {
          // GreenSky preQual conditional
          if ( this.lender.id === 'greensky' && this.hasPreQual) {
            await this.getGreenskyLegalContent();
            this.startPreQualFlow = true;
          }
          //If the lender is marlin, we find the appropriate merchant id for marlin and interpolate it into 
          //the redirect URL for the marlin application
          else if (this.lender.id==='marlin'){
            const marlin=this.activeAvailableLenders.find(l=>l.lender_id==='5')
            window.location.href=this.marlinURL
          }
          else {
            // check if it is greensky, then fetch legal content
            if(this.lender.id === 'greensky') await this.getGreenskyLegalContent();
            this.$router.push({
              path: '/credit-application/form-page-one'
            })
          }
        } else {
          this.checkPlanError = true
          this.checkLoanError = true
        }
      },
      send(payload, resolve, reject) {
        this.sendEasyLink(payload)
          .then(resolve)
          .catch(reject)
      },
      startLoanCheck() {
        const { loanAmount } = this
        this.setLoanAmount({ loanAmount })

        this.checkLoanError = true
      },
      resend(payload, resolve, reject) {
        this.resendEasyLink(payload)
          .then(resolve)
          .catch(reject)
      },
    },
    created () {
      this.loanAmount = (this.storeLoanAmount) ? this.storeLoanAmount : '$0'
    },
    async mounted() {
      // If GreenSky is an available lender, this will run a merchant validation call
      // to check validity of merchant and whether merchant has preQualification set up.
      // It then sets the call response in the preQual store module
      let greensky = this.activeAvailableLenders.find( l => l.lender_id === '1')
      if ( greensky ) {
        greenskyStatusCheck(greensky.merchant_id, { email: this.userEmail, lastName: this.userLastName })
          .then(res => {
            this.setState(['preQualification.isValid', res.data.isValid])
            this.setState(['preQualification.hasPreQual', res.data.isPreQualAllowed])
            this.setState(['user.greenskyTraining', res.data.greenskyTraining])
            if(res.data.greenskyTraining.duplicateAccounts){
              this.$store.dispatch('toast', `We found multiple GreenSky accounts associated with with your credentials. Please contact Merchant Support at: 800-357-1558`)
            } else {
              if (res.data.greenskyTraining.status === 'NotActive') {
                this.$store.dispatch('toast', 'Your GreenSky Account is not active. Contact Merchant Support at: 800-357-1558')
              } else if(res.data.greenskyTraining.status === 'Required') {
                this.$store.dispatch('toast', `Your Greensky Training is out-of-date. Take a few Minutes to complete it here: <a href="${res.data.greenskyTraining.trainingUrl}" target="_blank" rel="noopener noreferrer">Greensky Training</a>`)
              } else if(res.data.greenskyTraining.status === 'Pending') {
                this.$store.dispatch('toast', `Greensky Training available. Please take a few minutes to complete it before ${res.data.greenskyTraining.expirationDate}. You can find it here: <a href="${res.data.greenskyTraining.trainingUrl}" target="_blank" rel="noopener noreferrer">Greensky Training</a>`)
              } else if(res.data.greenskyTraining.status === 'InProgress') {
                this.$store.dispatch('toast', `Please take a few minutes to finish your Greensky Training before ${res.data.greenskyTraining.expirationDate}. You can find it here: <a href="${res.data.greenskyTraining.trainingUrl}" target="_blank" rel="noopener noreferrer">Greensky Training</a>`)
              } else if(res.data.greenskyTraining.status === 'InvalidResponse') {
                this.$store.dispatch('toast', `There is an problem with your Greensky Training Status. PLease try again later or contact Merchant Support at: 800-357-1558`)
              }
            }
          })
          .catch(err => {
            this.$store.dispatch('toast', 'There is an issue getting your training status. Please try again later.')
          })
      }   
      //Re-setting the condenser model and accessories to original state, in case applicant wants to re-start flow and choose again
      this.loanApplicationClear()
      this.getDealerPlans({dealerId: this.dealerId})

      //Re-set the preQualificationId state to null so dealer can send an EasyLink that will direct the user to Credit Application Page One
      if(this.preQualificationIdStatusCheck){
        this.savePreQualId(null)
      }
    } 
  }
</script>

<style lang="scss" scoped>
  .loan-wrapper {
    margin-top: 72px;
    margin-bottom: 72px;
  }

  .loan-input {
    font-size: 3em;
  }
</style>
